import Contacts                  from './Contacts/Contacts';
import User                      from './Users/User';
import Users                     from './Users/Users';
import Sources                   from './Sources/Sources';
import MailingLists              from './MailingLists/MailingLists';
import Statistics                from './Statistics/Statistics';
import Sections                  from './Sections/Sections';
import ScheduledContactDeletions from './Contacts/ScheduledDeletions';

export default {
    install(Vue) {
        Vue.component('contacts', Contacts);
        Vue.component('user', User);
        Vue.component('users', Users);
        Vue.component('sources', Sources);
        Vue.component('mailing-lists', MailingLists);
        Vue.component('statistics', Statistics);
        Vue.component('sections', Sections);
        Vue.component('scheduled-contact-deletions', ScheduledContactDeletions);
    }
};

export {
    Contacts,
    User,
    Users,
    Sources,
    MailingLists,
    Statistics,
    Sections,
    ScheduledContactDeletions
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/components.js